import { FC } from 'react';
import { Box, SxProps, Theme, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

type BaseCopyableTextProps = {
    value?: string | null;
    lines?: number;
    sx?: SxProps<Theme>;
};

const BaseCopyableText: FC<BaseCopyableTextProps> = ({ value, lines = 2, sx }) => {
    const { t } = useTranslation('common');

    if (!value) {
        return <Box sx={sx}>-</Box>;
    }

    return (
        <Tooltip
            arrow
            disableInteractive
            title={
                <>
                    <Box sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{t(value)}</Box>
                    <Box sx={{ mt: 0.5, opacity: 0.75, fontSize: 11 }}>{t('click to copy')}</Box>
                </>
            }
        >
            <Box
                component="span"
                onClick={() => navigator.clipboard?.writeText?.(value)}
                sx={{
                    display: '-webkit-box',
                    WebkitLineClamp: lines,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    wordBreak: 'break-word',
                    whiteSpace: 'normal',
                    cursor: 'copy',
                    ...sx,
                }}
            >
                {t(value)}
            </Box>
        </Tooltip>
    );
};

export default BaseCopyableText;
